/* Injects the subscription benefit list into the Seal Subscriptions widget
   as real markup (selectable, screen-reader accessible), in the page language.
   Copy approved by agency (Spiderwebmarketing) 14 Jul 2026 — figures
   (16,83 € / 11 %) refer to the 6 kg Gastric subscription, German market. */
(function () {
  var BENEFITS_BY_LANG = {
    de: [
      'Bei jeder Lieferung sparen: 16,83 € + gratis Versand deutschlandweit – rund 11 %',
      'Lieferintervalle frei wählbar – Termine jederzeit anpassbar, wann und wohin du willst',
      'Freie Wahl zwischen Pellets und Pulver',
      'Jederzeit pausierbar und kündbar'
    ],
    en: [
      'Save on every delivery: €16.83 + free shipping within Germany – around 11%',
      'Choose your own delivery interval – adjust date and address anytime',
      'Free choice between pellets and powder',
      'Pause or cancel anytime'
    ],
    nl: [
      "Bespaar bij elke levering: € 16,83 + gratis verzending binnen Duitsland – zo'n 11%",
      'Kies zelf je leverinterval – datum en adres altijd aan te passen',
      'Vrije keuze tussen pellets en poeder',
      'Altijd te pauzeren en op te zeggen'
    ]
  };
  var lang = (document.documentElement.lang || '').slice(0, 2).toLowerCase();
  var BENEFITS = BENEFITS_BY_LANG[lang];
  if (!BENEFITS) return;

  function inject() {
    var option = document.querySelector(
      '.sls-purchase-options-container .sls-option-container[data-selling-plan-group="0"]'
    );
    if (!option || option.querySelector('.abo-benefits')) return;

    var target = option.querySelector('.sls-label-container') || option;
    var list = document.createElement('ul');
    list.className = 'abo-benefits';
    BENEFITS.forEach(function (text) {
      var item = document.createElement('li');
      item.textContent = text;
      list.appendChild(item);
    });
    target.appendChild(list);
  }

  /* The Seal widget renders (and re-renders on variant change) after page
     load, so watch the DOM and re-inject whenever the list is missing. */
  new MutationObserver(inject).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  inject();
})();
